/* eslint-disable @typescript-eslint/explicit-function-return-type */
import XPMotorApi from '@xpeng/xpmotors-jsbridge-api';
import moment from 'moment';
import Cookie from 'js-cookie';
import bridge from '@xpeng/js-bridge';
import Report from '@xpeng/report-js';

/**
 * transformToQueryUrl: 将url转换成查询参数类型的url
 * @param url {string}
 * @param params {object}
 * @returns {string}
 */
export function transformToQueryUrl(url: string, params: any): string {
  let query = '';
  if (params && Object.keys(params).length > 0) {
    query = '?';
    let count = 1;
    for (let ele in params) {
      if (count < Object.keys(params).length) {
        query += ele + '=' + params[ele] + '&';
        count++;
      } else {
        query += ele + '=' + params[ele];
      }
    }
  }
  return url + query;
}

/**
 * 根据传入url及传递参数，跳转到对应的网页
 * @param {string} url 路径
 * @param {*} params 参数
 */
export function openUrl(url: string, params?: any, target?: string): void {
  console.log('url', url);

  var el = document.createElement('a');
  document.body.appendChild(el);
  el.href = transformToQueryUrl(url, params);
  el.target = target ? '_self' : '_blank';

  var e = document.createEvent('MouseEvents');
  e.initEvent('click', true, true);
  el.dispatchEvent(e);
  document.body.removeChild(el);
}

/**
 * 获取window.location.search的参数，返回一个对象，通过参数名获取值
 * @returns {object}
 */
export function getQueryObj(customSearch?: string): any {
  /* const params = new URLSearchParams(window.location.search);
  const obj: any = {};
  for (const key of params.keys()) {
    const vals = params.getAll(key);
    if (vals.length === 1) {
      obj[key] = vals[0];
    } else {
      obj[key] = vals;
    }
  }
  return obj; */
  const obj: any = {};
  let searchParams;
  if (customSearch) {
    searchParams = customSearch.substr(1);
  } else {
    searchParams = window.location.search.substr(1);
  }
  const params = searchParams.split('&');
  params.forEach(str => {
    const arr = str.split('=');
    if (arr[0] && arr[1]) {
      obj[arr[0]] = `${arr[1]}`;
    }
  });
  return obj;
}
/**
 * 平民版深拷贝对象方法
 * @param obj 被拷贝对象
 */
export function objectClone(obj: object): object {
  return JSON.parse(JSON.stringify(obj));
}
/**
 * 获取用户登录状态
 */
export function getLoginInfoPromise(): Promise<any> {
  return new Promise((resolve, reject): void => {
    XPMotorApi.getSdk()
      .callHandler('getLoginState', {})
      .then((res: any): void => {
        // loginState: true / false
        // data: {uid,username,avatar,mobile,carownerflag} | {}
        if (!res.loginState) {
          resolve(false);
        } else {
          resolve(res.data);
        }
      })
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 跳到登录页面
 */
export function goToLogin(): Promise<any> {
  return new Promise((resolve, reject): void => {
    XPMotorApi.getSdk()
      .callHandler('goToNativePage', {
        bizType: 'charge-web',
        pageType: 'login',
        transitionType: 0,
        data: {
          direct: window.location.href
        }
      })
      .then(res => {
        // code:1登录成功 0取消登录
        resolve(!!res.code);
      })
      .catch(err => {
        reject(err);
      });
  });
}
/**
 * 根据当前登录态强行进入登录界面，如果拒绝登录则刷新页面，重新进入页面。
 */
export function go2LoginIfNot(): Promise<any> {
  return new Promise((resolve, reject): void => {
    getLoginInfoPromise()
      .then((loginData: any): void => {
        if (!loginData) {
          goToLogin().then(success => {
            if (!success) {
              resolve(false);
            } else {
              console.log('页面刷新--', window.location);
              // window.location.reload();
              resolve(true);
            }
          });
        } else {
          resolve(loginData);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 适配跳页面
 * @param url 需要跳转的地址
 * @param innerData 内部协议需要独立传参
 */
export function jumpPage(url: string, innerData: any = {}): void {
  if (
    url.indexOf('http://') === 0 ||
    url.indexOf('https://') === 0 ||
    url.indexOf('./') === 0
  ) {
    // 增加延迟 用于上报数据
    setTimeout(() => {
      window.location.href = url
    }, 300)
  } else {
    XPMotorApi.getSdk().callHandler('openUrl', {
      url,
      data: innerData
    });
  }
}

/**
 * 获取当前平台：android还是iOS
 */
export function getPlatform() {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //判断是否是 android终端
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
  // console.log('是否是Android：' + isAndroid); //true,false
  // console.log('是否是iOS：' + isIOS);
  if (isAndroid) {
    return 'android';
  } else if (isIOS) {
    return 'iOS';
  } else {
    return 'PC';
  }
}

/**
 * 格式化时间戳
 * @param timestamp 时间戳
 * @param format 格式
 */
export function formatTs(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!timestamp) return '--'
  return moment(timestamp).format(format);
}

/**
 * @param timestamp 格式化时间戳到日期
 */
export function formateDate(timestamp) {
  return moment(timestamp).format('YYYY-MM-DD');
}

/**
 * @param timestamp 报装进度页格式化时间戳
 */
export function formateDatePile(timestamp) {
  return moment(timestamp).format('YYYY/MM/DD HH:mm:ss');
}

/**
 * @param timestamp 格式化时间为上下午时间 例：上午8点
 */
export function formateHourTime(timestamp) {
  let mydate = new Date(timestamp);

  let hour = mydate.getHours();
  let now = "";
  if (hour <= 12) {
    now = "上午";
  } else {
    hour -= 12
    now = "下午";
  }
  return now + hour + '点'
}

/**
 * @param timestamp 格式化时间为日期 今年：MM-DD 不是今年：YYYY-MM-DD
 */

export const formateDateIsNowYear = (timestamp) => {
  if (moment(timestamp).format('YYYY') === moment(new Date()).format('YYYY')) {
    return moment(timestamp).format('MM-DD');
  }
  return moment(timestamp).format('YYYY-MM-DD');
}


/**
 * @param timestamp 格式化时间戳到星期
 */
export function getDateWeek(timestamp) {
  const finalDay = new Date(timestamp);
  let Y: any = finalDay.getFullYear();
  let M: any = finalDay.getMonth() + 1;
  let D: any = finalDay.getDate();
  let W: any = finalDay.getDay();

  let b = '';
  switch (W) {
    case 0:
      b = '日';
      break;
    case 1:
      b = '一';
      break;
    case 2:
      b = '二';
      break;
    case 3:
      b = '三';
      break;
    case 4:
      b = '四';
      break;
    case 5:
      b = '五';
      break;
    default:
      b = '六';
  }
  if (M.toString().length == 1) {
    M = '0' + M;
  }
  if (D.toString().length == 1) {
    D = '0' + D;
  }
  const timeData = Y + '/' + M + '/' + D + ' ' + '周' + b;
  return timeData;
}

/**
 * 封装拼接url参数以便处理合理处理null和undefined值的问题
 * @param path
 * @param params
 */
export function generateUrlWithParam(path, params) {
  let paramsStr = '';
  const kvs: string[] = [];
  for (const key in params) {
    if (params[key]) {
      kvs.push(`${key}=${params[key]}`);
    }
  }
  paramsStr = kvs.join('&');
  return `${path}?${paramsStr}`;
}

/**
 * 返回当前页面的环境，依赖于当前域名
 */
export function getClientEnv() {
  let env = 'test';
  if (window.location.href.indexOf('static.deploy-test.xiaopeng.com') !== -1) {
    env = 'deploy';
  } else if (window.location.href.indexOf('static.xiaopeng.com') !== -1) {
    env = 'product';
  }
  return env;
}

export function getLogEnv() {
  return {
    product: 'production',
    dev: 'test',
    test: 'test',
    deploy: 'pre'
  }[getClientEnv()];
}

/**
 * 埋点
 */
export function reportUserBehavior(
  // N002（充电业务4G家充桩）
  // N002001（4G家充桩）
  // appId:N003（充电业务失败指导页面）
  // so:N003001（失败指导页面）
  { appid = 'N002', so = 'N002001', mcode = '', pa = '', ch = '', ut },
  type = 'event'
) {
  console.log('页面埋点：appid:' + appid + 'so:' + so + 'mcode:' + mcode + 'pa:' + pa);
  const report = new Report(
    {
      appid,
      so,
      mcode,
      pa,
      ch,
      ut
    },
    {
      env: getLogEnv()
    }
  );
  report.send({ type });
}

/**
 * 选择的vin码缓存
 */
export const VinCache = {
  key: 'selected-vin',
  getCache() {
    const data = window.localStorage.getItem(this.key);
    return data;
  },
  refreshCache(val) {
    window.localStorage.setItem(this.key, val);
  }
};
// 关闭h5在App的分享按钮，iOS默认不可以分享，安卓默认可以分享
export function disableShare() {
  XPMotorApi.setOnActionButtonShowingHandler(() => {
    return { data: { share: false } };
  });
}
// 关闭浏览器
export function closeWindow() {
  XPMotorApi.getSdk().callHandler('closeWindow');
}
// 回调数据给上一层页面
export function callbackData(data) {
  XPMotorApi.getSdk().callHandler('setResult', data);
}
export function debounce<T>(fn: Function, delay = 200) {
  console.log("debounce");

  let lastFn: any;
  return function (this: T, ...args) {
    if (lastFn) {
      clearTimeout(lastFn);
    }
    lastFn = setTimeout(() => {
      lastFn = null;
      fn.call(this, ...args);
    }, delay);
  };
}
// 异步加载脚本
export function loadScript(scriptUrl: string, id: string): Promise<any> {
  const $body = document.body;
  if (!id) throw new Error('id is needed');
  if (!scriptUrl) throw new Error('scriptUrl is needed, please');
  // 没有id则url转base64，取一个唯一值
  // if (!id) {
  //   id = encodeURIComponent(window.btoa(scriptUrl));
  // }
  if (!$body) throw new Error(`cant get the document body, try again`);
  const pro = new Promise((resolve: Function, reject: Function) => {
    // 避免缓存
    const $oldScript = document.getElementById('#' + id);
    if ($oldScript) {
      resolve();
      return;
    }
    const $script = document.createElement('script');
    $script.id = id;
    $script.type = 'text/javascript';
    $script.onload = () => {
      resolve();
    };
    $script.onerror = err => {
      reject(err);
    };
    $script.src = scriptUrl;
  });
  return pro;
}
// 设置导航投隐藏 慎用
export function transparentHeader(): Promise<any> {
  return XPMotorApi.getSdk().callHandler('modifyNavBarAlpha', { alpha: 0 });
}
// 调用原生定位方法
export function requestLocation(): Promise<any> {
  return XPMotorApi.getSdk().callHandler('requestLocation', {});
}
// 原生新开webview
export function webviewOpen(url, data?) {
  XPMotorApi.getSdk().callHandler('openUrl', {
    url,
    data
  });
}
// jsbridge的方法不是很好用，摘取自判断ua的方式来判断app
export function isInApp() {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf('xiaopeng') !== -1;
}

//除法函数，用来得到精确的除法结果
//说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
//调用：accDiv(arg1,arg2)
//返回值：arg1除以arg2的精确结果
export function accDiv(arg1, arg2) {
  let t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = arg1.toString().split('.')[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) { }
  try {
    t2 = arg2.toString().split('.')[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) { }
  r1 = Number(arg1.toString().replace('.', ''));
  r2 = Number(arg2.toString().replace('.', ''));
  return (r1 / r2) * Math.pow(10, t2 - t1);
}
//乘法函数，用来得到精确的乘法结果
//说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
//调用：accMul(arg1,arg2)
//返回值：arg1乘以arg2的精确结果
export function accMul(arg1, arg2) {
  let m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) { }
  try {
    m += s2.split('.')[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) { }
  return (
    (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m)
  );
}
//加法函数，用来得到精确的加法结果
//说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
//调用：accAdd(arg1,arg2)
//返回值：arg1加上arg2的精确结果
export function accAdd(arg1, arg2) {
  let r1, r2, m;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m) / m;
}
//减法函数
export function accSub(arg1, arg2) {
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  //动态控制精度长度
  n = r1 >= r2 ? r1 : r2;
  return ((arg2 * m - arg1 * m) / m).toFixed(n);
}

export function gotoMapNav(
  latitude?: number,
  longitude?: number,
  label?: string
) {
  XPMotorApi.getSdk().callHandler('navigate', {
    // 地址
    label: label,
    latitude: latitude,
    longitude: longitude
  });
}

export function sendToMyCar(
  latitude?: number,
  longitude?: number,
  name?: string,
  label?: string
) {
  XPMotorApi.getSdk().callHandler('sendAddress', {
    // 地点名
    userName: name,
    // 地址
    label: label,
    latitude: latitude,
    longitude: longitude
  });
}
// 版本位数不同一律为小于 -1：小于 0： 等于 1：大于
export function versionCompare(myVersion, targetVersion) {
  const myVersionArr = myVersion.split('.');
  const targetVersionArr = targetVersion.split('.');
  if (myVersionArr.length !== targetVersionArr.length) {
    return -1;
  }
  if (myVersion === targetVersion) {
    return 0;
  }
  let i = 0;
  while (i < targetVersionArr.length) {
    if (Number(myVersionArr[i]) > Number(targetVersionArr[i])) {
      return 1;
    }
    if (Number(myVersionArr[i]) < Number(targetVersionArr[i])) {
      return -1;
    }
    i++;
  }
  return -1;
}
export function isNowVersionUpOrMatch(targetVersion) {
  const ua = window.navigator.userAgent.toLowerCase();

  const REGEX = /^.*[com.tentcoo.XiaoPengQiCheEnterprise|com.xiaopeng.XiaoPengQiChe|com.xiaopeng.mycarinfo]\/([\d|.]*)/;
  const regResult = REGEX.exec(ua);
  if (regResult && regResult.length) {
    const curVersion = regResult[1].trim();
    return versionCompare(curVersion, targetVersion);
  }
  console.error('获取不到版本号');
  return -1;
}

/**
 * [通过参数名获取url中的参数值]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
 * @param  {[string]} queryName [参数名]
 * @return {[string]}           [参数值]
 */
export function getUrlValue(queryName) {
  let reg = new RegExp('(^|&)' + queryName + '=([^&]*)(&|$)', 'i');
  const query = window.location.search; // '?s=1&f=7'
  console.log('获取链接参数query');

  console.log(window.location);
  let r = query.substr(1).match(reg);
  console.log(r);
  if (r != null) {
    return decodeURI(r[2]);
  } else {
    return null;
  }
}

export function getUrlValueFromUrl(url: string, queryName: string) {
  const paramsString = url.split('?')[1] || '';
  const items = paramsString.split('&') || '';
  var params = {};
  if (items) {
    items.forEach(item => {
      const arr = item.split('=');
      const key = arr[0];
      const value = arr[1];
      params[key] = value;
    });
  }
  return params[queryName];
}

/**
 * 导航栏隐藏
 */
export function navHide() {
  if (isInApp()) {
    if (getPlatform() === 'iOS') {
      bridge.callHandler('modifyNavBarAlpha', { alpha: 0 })
    } else {
      bridge.callHandler('setFullScreen', { fullScreen: true, darkMode: true })
    }
  }
}

/**
 * 导航栏恢复
 */
export function navShow() {
  if (isInApp()) {
    if (getPlatform() === 'iOS') {
      bridge.callHandler('modifyNavBarAlpha', { alpha: 1 })
    } else {
      bridge.callHandler('setFullScreen', { fullScreen: false, darkMode: false });
    }
  }
}

/**
 * [isXPApp]如果页面回退
 */

export function pageShow(callback?) {
  if (isInApp()) {
    window.onpageshow = function (event) {
      if (event.persisted && typeof callback === 'function') {
        callback();
      }
    };

    bridge.registerHandler('onResult', function () {
      if (typeof callback === 'function') {
        callback();
      }
    });
  }
}

export interface ShareType {
  shareTitle: string;
  shareDesc: string;
  sharePicUrlAccess: string;
}
/**
 * APP、wx、小程序、骁龙、浏览器内的分享功能处理
 * ---
 * @param shareParam
 * @param shareParam.shareTitle - 分享标题
 * @param shareParam.shareDesc - 分享详情文本
 * @param shareParam.sharePicUrlAccess - 分享icon
 * @param shareUrl -分享url
 * @param posterImageBase64 -如果传该参数，APP则会启用分享海报, 分享的海报图片 base64 格式 需要移除头（比如：function已经处理该头 --->【/^data:image\/(jpeg|png|jpg);base64,/】 如果不一致，需要自己处理 ）
 */

export function simpleShare({ shareTitle, shareDesc, sharePicUrlAccess }: ShareType, shareUrl: string, posterImageBase64?: string) {
  console.log("simpleShare", isInApp());

  if (isInApp()) {
    console.log("inAPP");

    if (posterImageBase64) {
      bridge.callHandler('sharePanel', {
        style: 4, // 海报专用分享面板
        addExtInfo: false, // 是否添加二维码等补充
        addUserInfo: false, // 是否添加用户信息
        addQrCode: false,
        data: {
          shareType: 2, // 虽然已经明确是海报分享，还是需要设置分享数据类型为图像
          title: shareTitle,
          content: shareDesc,
          postImage: posterImageBase64.replace(/^data:image\/(jpeg|png|jpg);base64,/, ''),
        }
      })
    } else {
      console.log("notinAPP");
      bridge.callHandler('sharePanel', {
        style: 0,
        data: {
          title: shareTitle,
          content: shareDesc,
          url: encodeURIComponent(shareUrl),
          thumImageUrl: sharePicUrlAccess || '',
          shareType: 3,
        },
      })
        .catch(console.error);
    }
  }
}

function half(number) {
  return number / 2;
}

const getCarString = (carList: string[]) => {
  let result = ''
  if (carList.length > 0) {
    carList.map((item, index) => {
      if (index === 0) {
        result = result + item
      } else {
        result = result + `/${item}`
      }
    })
  }
  return result
}

/**
 * 生成海报
 * -
 * @param param
 * @param param.posterUrl // 海报背景图
 * @param imageType // 图片格式 如 【jpg/jpeg/png】
 * @param detail // 充电估算信息
 * @returns
 */
export function generatePoster(
  {
    bottomUrl,
    posterUrl,
    detail: {
      totalDistance,
      chargeAmt,
      chargeFee,
      chgSaveThanOilFee,
      carbonDeduction,
      treeNum
    }
  }, imageType = 'png'
): Promise<string> {

  console.log('generatePoster');

  return new Promise((resolve, reject) => {
    console.log('devicePixelRatio');
    const canvas = document.createElement('canvas');
    const ratio = (window.devicePixelRatio || 1) + 1;
    canvas.width = 375 * ratio;
    canvas.height = 812 * ratio;

    let store: HTMLImageElement[] = [];
    const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
    ctx.scale(ratio, ratio)

    // 首先清空画布
    ctx.clearRect(0, 0, 375, 812);
    ctx.save();

    function checkStore(HTMLImageElement) {
      store = store.filter(item => item !== HTMLImageElement);
      console.log('HTMLImageElement', HTMLImageElement);
      console.log('store', store);
      console.log('store111', store.length);

      if (store.length === 0) {
        resolve(canvas.toDataURL(`image/${imageType}`, 1))
      }
    }

    // 单位左边与数字的距离
    const unitLeft = 5

    const bgImage = new Image();
    bgImage.crossOrigin = 'anonymous';
    bgImage.src = posterUrl;
    bgImage.onerror = reject;
    console.log('准备  bgImage.onload');

    bgImage.onload = () => {
      console.log('bgImage.onload');
      ctx.drawImage(bgImage, 0, 0, 375, 812);

      // let i = ctx.measureText('').width

      // 我的充电估算
      ctx.font = `normal 600 ${26}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'center'
      ctx.fillText('我的充电估算', half(375), 130);

      // 快速估算出行距离与充电费用
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'center'
      ctx.fillText('快速估算出行距离与充电费用', half(375), 160);

      {/** 每年出行距离 */ }
      // 数字
      ctx.font = `normal 500 ${30}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'left'
      ctx.fillText(totalDistance, 72, 262);

      // 公里
      const totalDistanceLength = ctx.measureText(totalDistance).width
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = 'rgba(0, 0, 0, 0.6)'
      ctx.textAlign = 'left'
      ctx.fillText('公里', 72 + unitLeft + totalDistanceLength, 260);

      // 每年出行距离
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'left'
      ctx.fillText('每年出行距离', 72, 285);

      {/** 年度充电度数 */ }

      // 数字
      ctx.font = `normal 500 ${30}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'left'
      ctx.fillText(chargeAmt, 225, 262);

      // 度
      const chargeAmtLength = ctx.measureText(chargeAmt).width
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = 'rgba(0, 0, 0, 0.6)'
      ctx.textAlign = 'left'
      ctx.fillText('度', 225 + unitLeft + chargeAmtLength, 260);
      // 年度充电度数
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'left'
      ctx.fillText('年度充电度数', 225, 285);

      {/** 年度充电费用 */ }
      // 数字
      ctx.font = `normal 500 ${30}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'left'
      ctx.fillText(chargeFee, 70, 348);
      // 元
      const chargeFeeLength = ctx.measureText(chargeFee).width
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = 'rgba(0, 0, 0, 0.6)'
      ctx.textAlign = 'left'
      ctx.fillText('元', 70 + unitLeft + chargeFeeLength, 346);

      // 年度充电费用
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'left'
      ctx.fillText('年度充电费用', 70, 370);


      {/** 对比燃油节省 */ }
      // 数字
      ctx.font = `normal 500 ${30}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'left'
      ctx.fillText(chgSaveThanOilFee, 225, 348);
      // 元
      const chgSaveThanOilFeeLength = ctx.measureText(chgSaveThanOilFee).width
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = 'rgba(0, 0, 0, 0.6)'
      ctx.textAlign = 'left'
      ctx.fillText('元', 225 + unitLeft + chgSaveThanOilFeeLength, 346);
      // 对比燃油节省
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'left'
      ctx.fillText('对比燃油节省', 225, 370);



      // 省钱之余，我还
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'center'
      ctx.fillText('省钱之余，我还', half(375), 440);
      // 对
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'left'
      ctx.fillText('对', 90, 470);
      // 地球生态环保
      ctx.font = `normal 500 ${17}px 'Futura'`;
      ctx.fillStyle = '#6DA23A'
      ctx.textAlign = 'left'
      ctx.fillText('地球生态环保', 107, 471);
      // 做出了贡献！
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'left'
      ctx.fillText('做出了贡献！', 212, 470);


      // 动态匹配长度
      let bottomConnentLength = 0
      ctx.font = `normal 400 ${14}px 'Futura'`;
      bottomConnentLength = bottomConnentLength + ctx.measureText('达成碳减排  kg，相当于植树  棵').width
      ctx.font = `normal 500 ${21}px 'Futura'`;
      bottomConnentLength = bottomConnentLength + ctx.measureText(carbonDeduction).width
      bottomConnentLength = bottomConnentLength + ctx.measureText(treeNum).width
      let renderLeft = half(375 - bottomConnentLength)

      // 达成碳减排
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'left'
      ctx.fillText('达成碳减排 ', renderLeft, 500);
      renderLeft = renderLeft + ctx.measureText('达成碳减排 ').width

      // 数据
      ctx.font = `normal 500 ${21}px 'PingFang SC'`;
      ctx.fillStyle = '#6DA23A'
      ctx.textAlign = 'left'
      ctx.fillText(carbonDeduction, renderLeft, 502);
      renderLeft = renderLeft + ctx.measureText(carbonDeduction).width

      // kg
      ctx.font = `normal 400 ${14}px 'PingFang SC'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'left'
      ctx.fillText(' kg', renderLeft, 500);
      renderLeft = renderLeft + ctx.measureText(' kg').width

      // ，相当于植树
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'left'
      ctx.fillText('，相当于植树 ', renderLeft, 500);
      renderLeft = renderLeft + ctx.measureText('，相当于植树 ').width

      // 数据
      ctx.font = `normal 500 ${21}px 'PingFang SC'`;
      ctx.fillStyle = '#6DA23A'
      ctx.textAlign = 'left'
      ctx.fillText(treeNum, renderLeft, 502);
      renderLeft = renderLeft + ctx.measureText(treeNum).width

      // 棵
      ctx.font = `normal 400 ${14}px 'Futura'`;
      ctx.fillStyle = '#000'
      ctx.textAlign = 'left'
      ctx.fillText(' 棵', renderLeft, 500);

      // 底部二维码&葵花码
      const bottomImage = new Image();
      store.push(bottomImage);
      bottomImage.crossOrigin = 'anonymous';
      bottomImage.src = bottomUrl;
      bottomImage.onerror = reject;
      bottomImage.onload = () => {
        console.log('bottomUrl', bottomImage);
        ctx.drawImage(bottomImage, 30, 713, 315, 66);
        ctx.restore();
        checkStore(bottomImage);
      }
    }
  })
}


function drawRoundedRect(ctx, x, y, width, height, r, fill = false, stroke = false) {
  ctx.save();
  ctx.beginPath();

  // draw top and top right corner
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + width, y, x + width, y + r, r);

  // draw right side and bottom right corner
  ctx.arcTo(x + width, y + height, x + width - r, y + height, r);

  // draw bottom and bottom left corner
  ctx.arcTo(x, y + height, x, y + height - r, r);

  // draw left and top left corner
  ctx.arcTo(x, y, x + r, y, r);

  if (fill) {
    ctx.fill();
  }

  if (stroke) {
    ctx.stroke();
  }

  ctx.restore();
}
/**
 * 对数字或者数字字符串添加千分符
 * @param numStr
 * @returns
 */
export const addThousandthSign = (numStr?: string | number) => {
  if (!numStr) return '--'
  const regForm = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g;
  return numStr.toString().replace(regForm, '$1,');
};



function loadJs(src) {
  return new Promise((resolve, reject) => {
    const ref = document.getElementsByTagName('script')[0];
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    (ref.parentNode as any).insertBefore(script, ref);
    script.onload = resolve;
    script.onerror = reject;
  });
}
function load(url: string) {
  return loadJs(url).catch(() => loadJs(url));
}
export function wxInit(): Promise<any> {
  // 避免重复加载
  // @ts-ignore
  if (window.wx && typeof window.wx.config === 'function') {
    console.log('wx获取了缓存的SDK')
    // @ts-ignore
    return Promise.resolve(window.wx);
  }

  // 加载 jssdk 后初始化
  return load('//res.wx.qq.com/open/js/jweixin-1.6.0.js#wechat_redirect')
    // @ts-ignore
    .then(() => Promise.resolve(window.wx));
}
// 支付宝小程序
export function myInit(): Promise<any> {
  // 避免重复加载
  // @ts-ignore
  if (window.my && window.my.navigateTo) {
    // @ts-ignore
    return Promise.resolve(window.my);
  }

  // 加载 jssdk 后初始化
  return load('//appx/web-view.min.js')
    // @ts-ignore
    .then(() => Promise.resolve(window.my));
}

export const throttle = (fn, delay) => {
  let timer;
  return (...arg) => {
    if (timer) return
    timer = setTimeout(() => {
      fn(...arg);
      clearTimeout(timer);
      timer = undefined
    }, delay)
  }
}


export const flatten = (arr) => {
  return arr.reduce((res, next) => {
    return res.concat(Array.isArray(next) ? flatten(next) : next)
  }, [])
}



export const uuidGenerator = (len?, radix?) => {
	const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	let uuid: any[] = [], i;
	radix = radix || chars.length;
	len = len || 16;

	if (len) {
		// Compact form
		for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
	} else {
		// rfc4122, version 4 form
		let r;

		// rfc4122 requires these characters
		uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
		uuid[14] = '4';

		// Fill in random data.  At i==19 set the high bits of clock sequence as
		// per rfc4122, sec. 4.1.5
		for (i = 0; i < 36; i++) {
			if (!uuid[i]) {
				r = 0 | Math.random() * 16;
				uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
			}
		}
	}

	return uuid.join('');
};

// 获取设备ID
export const getDeviceId = (cookieName: string) => {
	if (Cookie.get(cookieName)) {
		return Cookie.get(cookieName);
	} else {
		const deviceId = uuidGenerator();
		Cookie.set(cookieName, deviceId, { expires: 7, path: '/' });
		return deviceId;
	}
};


export const getChannel = () => {
  const UA = navigator.userAgent || "";
  const isDragon = /XdragonWebView/i.test(UA); // 骁龙app
  const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
  const isWX = /micromessenger/i.test(UA); // 微信
  const isWXApp = isWX && /miniProgram/i.test(UA); // 微信小程序
  const isMyApp = /AliApp/i.test(UA) && /miniProgram/i.test(UA); // 支付宝小程序
  if (isXPApp) {
    return 'xpApp'
  } else if (isMyApp || isWXApp) {
    return isMyApp ? 'alipay' : 'weapp'
  } else if (isDragon) {
    return 'dragon'
  } else {
    return 'browser'
  }
}

// 获取域名
export const getDomain = () => {
  let apiDomain = "";
  if (window.location.href.indexOf("static.deploy-test.xiaopeng.com") !== -1) {
    apiDomain = "https://chargegateway.deploy-test.xiaopeng.com";
  } else if (window.location.href.indexOf("static.xiaopeng.com") !== -1) {
    apiDomain = "https://chargegateway.xiaopeng.com";
  } else {
    apiDomain = "https://chargegateway.deploy-test.xiaopeng.com";
  }
  return apiDomain;
};

/**
 * 由于当前充电H5的路由是hash模式，所有的query参数都在hash中，所以需要从hash中获取参数，否则在小程序端会获取不到
 */
export const getParamsFromHash = (key: string) => {
  const params = {}
  const hash = window.location.hash;
  const queryString = hash.split('?')[1];
  if (queryString) {
    queryString.split('&').forEach(item => {
      const [key, value] = item.split('=');
      params[key] = value;
    })
  }
  return params[key];
}

export const getParamsFromHref = (key: string) => {
  const params = {}
  const href = window.location.href;
  const queryString = href.split('?')[1];
  if (queryString) {
    queryString.split('&').forEach(item => {
      const [key, value] = item.split('=');
      params[key] = value;
    })
  }
  return params[key];
}

/**
 * 判断一个元素是否在可视窗口内
 * @param element 
 * @returns
 */
export function isInViewPort(element, navHeight = 0) {
  const viewWidth = window.innerWidth || document.documentElement.clientWidth;
  const viewHeight = window.innerHeight || document.documentElement.clientHeight;
  const {
    top,
    right,
    bottom,
    left,
  } = element.getBoundingClientRect();

  if (navHeight > 0) {
    return (
      top >= navHeight &&
      left >= 0 &&
      right <= viewWidth &&
      bottom <= viewHeight
    );
  }
  
  return (
    top >= 0 &&
    left >= 0 &&
    right <= viewWidth &&
    bottom <= viewHeight
  )
}

export const scrollLock = {
  enable: () => {
    let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
    document.body.style.cssText += 'position:fixed;width:100%;top:-' + scrollTop + 'px;'
  },
  disable: () => {
    let body = document.body
    body.style.position = ''
    let top = body.style.top
    document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top)
    body.style.top = ''
  }
}
